<nz-row [nzAlign]="'middle'" [nzJustify]="'center'">
  <nz-col [nzSpan]="24">
    <nz-result
      [nzStatus]="'404'"
      [nzTitle]="'404'"
      i18n-nzSubTitle="@@page-not-found-content-result-subtitle"
      nzSubTitle="Sorry, the page you visited does not exist">
      <div nz-result-extra>
        <button
          [nzType]="'primary'"
          [routerLink]="'/'"
          i18n="@@go-back-to-search"
          nz-button>
          Go back to search
        </button>
      </div>
    </nz-result>
  </nz-col>
</nz-row>
